import React from "react";
import { microCopy } from "@bmi-digital/dxb-microcopies";
import { useSiteContext } from "../Site";
import {
  classes,
  StyledListItem,
  StyledListWrapper,
  StyledCheckIcon
} from "./styles/PasswordCriteriaStyles";
import type { PasswordCriteriaProps } from "./types";

const PasswordCriteria = (props: PasswordCriteriaProps) => {
  const { getMicroCopy } = useSiteContext();

  return (
    <StyledListWrapper data-testid="password-criteria-wrapper">
      <StyledListItem
        data-testid="password-criteria-lowercase-letters-or-digits"
        className={
          props.passwordStatus.hasLowerCaseLettersOrDigits
            ? classes.criteriaMet
            : undefined
        }
      >
        {props.passwordStatus.hasLowerCaseLettersOrDigits && (
          <StyledCheckIcon />
        )}
        {getMicroCopy(microCopy.PASSWORD_VALIDATION_LOWER_CASE_LETTER_OR_DIGIT)}
      </StyledListItem>
      <StyledListItem
        data-testid="password-criteria-capital-letters"
        className={
          props.passwordStatus.hasCapitalLetter
            ? classes.criteriaMet
            : undefined
        }
      >
        {props.passwordStatus.hasCapitalLetter && <StyledCheckIcon />}
        {getMicroCopy(microCopy.PASSWORD_VALIDATION_CAPITAL_LETTER)}
      </StyledListItem>
      <StyledListItem
        data-testid="password-criteria-special-letters"
        className={
          props.passwordStatus.hasSpecialCharacters
            ? classes.criteriaMet
            : undefined
        }
      >
        {props.passwordStatus.hasSpecialCharacters && <StyledCheckIcon />}
        {getMicroCopy(microCopy.PASSWORD_VALIDATION_SPECIAL_CHARACTERS)}
      </StyledListItem>
      <StyledListItem
        data-testid="password-criteria-length"
        className={
          props.passwordStatus.isLengthCorrect ? classes.criteriaMet : undefined
        }
      >
        {props.passwordStatus.isLengthCorrect && <StyledCheckIcon />}
        {getMicroCopy(microCopy.PASSWORD_VALIDATION_LENGTH)}
      </StyledListItem>
    </StyledListWrapper>
  );
};

export default PasswordCriteria;
